import {
  RatingsFilterValue,
  RatingEnhancementFilterModel
} from './ratings-filters';
import { BasicDeal } from '../../../../types/deal.types';
import { FilterResultFacade } from '../../../../helpers/filters/filter-result-facade';

abstract class RatingDealLevelFilterStrategy {
  protected minValue: number;
  protected maxValue: number;
  protected filterResult: FilterResultFacade;
  protected filterName: string;
  public abstract apply(deal: BasicDeal): boolean;

  public config(filterResult: FilterResultFacade, filterName: string): void {
    this.filterResult = filterResult;
    this.filterName = filterName;
  }
}

class AtLeastOneSeriesRatingsMathFilterStrategy extends RatingDealLevelFilterStrategy {
  public apply(deal: BasicDeal): boolean {
    return this.someSeriesHasAppropriateRating(deal.id);
  }

  private someSeriesHasAppropriateRating(dealId: string) {
    return this.filterResult.someSeriesPassedFilter(dealId, this.filterName);
  }
}

class NotRatedRatingFilterDealLevelStrategy extends RatingDealLevelFilterStrategy {
  public apply(deal: BasicDeal): boolean {
    return this.everySeriesHasNoRating(deal.id);
  }

  private everySeriesHasNoRating(dealId: string) {
    return this.filterResult.everySeriesPassedFilter(dealId, this.filterName);
  }
}

export class RatingDealLevelFilter {
  private isFilterActive: boolean;

  private stateStrategies = {
    [RatingsFilterValue.all]: new AtLeastOneSeriesRatingsMathFilterStrategy(),
    [RatingsFilterValue.rated]: new AtLeastOneSeriesRatingsMathFilterStrategy(),
    [RatingsFilterValue.notRated]: new NotRatedRatingFilterDealLevelStrategy()
  };

  private selectedStrategy: RatingDealLevelFilterStrategy;

  constructor(
    model: RatingEnhancementFilterModel,
    filterResult: FilterResultFacade,
    filterName: string
  ) {
    this.isFilterActive =
      !!model && model.isFilterActive && !!model.ratingsRadio;
    if (this.isFilterActive) {
      this.selectedStrategy = this.stateStrategies[model.ratingsRadio];
      this.selectedStrategy.config(filterResult, filterName);
    }
  }

  applyFilter(deal: BasicDeal): boolean {
    if (!this.isFilterActive) {
      return true;
    }
    return this.selectedStrategy.apply(deal);
  }
}
